import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./NavbarWithoutLogo.css";
import ContactModal from "../Contact/ContactModal";
import LoginModal from "../Login/LoginModal";
import logo from "./image.png";
import { FaShoppingCart, FaUser } from "react-icons/fa";

const CustomNavbarWithoutLogo = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);
  const navigate = useNavigate();
  const { cartCount } = useCart();

  const handleOpenContactModal = () => setIsContactModalOpen(true);
  const handleCloseContactModal = () => setIsContactModalOpen(false);

  const handleOpenLoginModal = () => setIsLoginModalOpen(true);
  const handleCloseLoginModal = () => setIsLoginModalOpen(false);

  const handleScrollTo = (sectionId) => {
    navigate("/");
    setTimeout(() => {
      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  };

  const handleGoToHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Manejar la visibilidad del navbar al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowNavbar(true);
      } else {
        setShowNavbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        className={`custom-navbar-without-logo ${showNavbar ? "visible" : "hidden"}`}
      >
        <Container>
          {/* Logo y nombre */}
          <div className="logo-container" onClick={handleGoToHome} style={{ cursor: "pointer" }}>
            <img src={logo} alt="Deluxe Labs Logo" className="logo-img" />
            <span className="brand-name">Deluxe Labs</span>
          </div>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="m-auto">
              <Nav.Link onClick={handleGoToHome}>Inicio</Nav.Link>
              <Nav.Link as={NavLink} to="/productos">
                Productos
              </Nav.Link>
              <Nav.Link onClick={() => handleScrollTo("#sube-tu-diseño")}>
                Sube tu diseño
              </Nav.Link>
              <Nav.Link onClick={handleOpenContactModal} className="contact-btn">
                Contáctanos
              </Nav.Link>
              {/* Log in dentro del menú desplegable */}
              <Nav.Link className="nav-link-login" onClick={handleOpenLoginModal}>
                Log in
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <div className="user-cart-wrapper">
            <div className="login-wrapper" onClick={handleOpenLoginModal}>
              <FaUser size={20} className="user-icon" />
              <span className="login-text">Log in</span>
            </div>
            <div className="cart-icon-wrapper">
              <div className="cart-icon" onClick={() => navigate("/carrito")}>
                <FaShoppingCart size={24} />
                <span className="cart-count">{cartCount}</span>
              </div>
            </div>
          </div>
        </Container>
      </Navbar>
      <ContactModal isOpen={isContactModalOpen} onClose={handleCloseContactModal} />
      <LoginModal isOpen={isLoginModalOpen} onClose={handleCloseLoginModal} />
    </>
  );
};

export default CustomNavbarWithoutLogo;
